import { useEffect } from 'react';

import type { RouteIdType, RouterState } from '@trello/router';
import { isActiveRoute, RouteId, routerState } from '@trello/router';

import { setDocumentTitle } from 'app/src/components/DocumentTitle';
import { useBoardTitleFragment } from './BoardTitleFragment.generated';

export const useBoardTitle = (boardId: string) => {
  const { data: board } = useBoardTitleFragment({
    from: { id: boardId },
  });

  useEffect(() => {
    const handleRouteChange = (route: RouterState<RouteIdType>) => {
      if (board?.name && isActiveRoute(route, RouteId.BOARD)) {
        setDocumentTitle(board?.name);
      }
    };

    const unsubscribe = routerState.subscribe(handleRouteChange);
    handleRouteChange(routerState.value);

    return () => {
      unsubscribe();
    };
  }, [board?.name]);
};
